module.exports = __webpack_public_path__ + "static/media/key-fill.f65c10b8.svg";